import React from "react";
import "./contact.css";
import Marktdees from "../../img/markt-dees.jpg"; // nieuwe bestandsnaam

export default function ContactPage() {
  return (
    <section className="contact-section">
      <div className="contact-content">
        <div className="contact-text">
          <h2> Neem contact op met Dees!</h2>
          <p>
            Heb je vragen, wil je meer weten over een workshop of gewoon even
            hallo zeggen? 🎨 Hieronder vind je alle manieren om contact met mij
            op te nemen. Ik hoor graag van je! 💌
          </p>

          <div className="contact-card">
            <ul className="contact-list">
              <li>
                <span>📍</span> <strong>Adres:</strong> Wauwbach, gemeente
                Landgraaf
              </li>
              <li>
                <span>📧</span> <strong>E-mail:</strong>{" "}
                <a href="mailto:deesgardeniers@hotmail.com">
                  deesgardeniers@hotmail.com
                </a>
              </li>
              <li>
                <span>📱</span> <strong>Telefoon:</strong>{" "}
                <a href="tel:+31612345678">06 53888195</a>
              </li>
              <li>
                <span>⏰</span> <strong>Beschikbaar:</strong> Maandag t/m
                vrijdag, 09:00 - 17:00
              </li>
              <li>
                <span>🎪</span> <strong>Kunstbraderie:</strong> Festival des
                Arts elk jaar op de 1e zondag van juli
              </li>
            </ul>
          </div>
        </div>

        <div className="contact-image">
          <img src={Marktdees} alt="Dees Gardeniers" />
        </div>
      </div>
    </section>
  );
}
